import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const STORAGE_KEY = 'isuru-cookie-consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (e) {
      /* storage blocked — just hide for this session */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Cookie notice" aria-live="polite">
      <p className="cookie-consent-text">
        I only use essential cookies to keep this site running — no tracking, no ads.{' '}
        <Link to="/cookies">Learn more</Link>.
      </p>
      <button className="cookie-consent-btn" onClick={accept}>
        Got it
      </button>
    </div>
  );
};

export default CookieConsent;
